export default {
  id: 'generating-report',
  title: 'Generating a Report',
  content: `## Generating a Trade Report

TradeLab can generate a comprehensive Trade Report covering your performance and behavioral metrics over any time period. Reports can be downloaded as PDF or Word documents, or delivered to your email.

---

## Where to Find It

**Profile → Trade Reports → Generate New Report**

---

## Report Types

| Report | Time period | Best used for |
|---|---|---|
| Weekly Summary | Last 7 trading days | Quick weekly review — habits and P&L |
| Monthly Report | Last 30 days | Monthly performance and behavioral audit |
| Quarterly Report | Last 90 days | Longer-term trend identification |
| Custom Range | Any start and end date | Specific period analysis |

---

## Report Format Options

| Format | What you get |
|---|---|
| PDF | A formatted, print-ready report with charts and tables |
| Word (DOCX) | Editable document — useful for adding your own notes |
| Email delivery | Report sent directly to your registered email address |

---

## How to Generate

1. Tap **Generate New Report**
2. Select the report type or set a custom date range
3. Choose the output format (PDF / Word / Email)
4. For email: confirm your email address is correct
5. Tap **Generate**

Report generation typically takes 15–30 seconds. PDF and Word reports are available to download immediately. Email delivery arrives within a few minutes.

---

## What Triggers Email Delivery

If you select email delivery, the report is sent to your registered email address (the one used to sign up). Ensure your email is correct under **Profile → Profile Details**.

> Email delivery uses SMTP and may land in your Promotions or Spam folder on first send. Mark it as "Not Spam" to ensure future reports arrive in your inbox.

---

## Report History

Previously generated reports are stored under **Profile → Trade Reports → Report History**. You can re-download any past report without regenerating it.

---

## Scheduling Regular Reports

You can set TradeLab to automatically generate and email a weekly summary every Monday morning. To enable:

**Profile → Trade Reports → Schedule → Weekly Email → On**

This delivers a summary of the prior week's trading activity to your inbox every Monday before market open.`,
};
